import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';

import { AuthService, UserRole } from './auth.service';
import { FeatureGateService } from './feature-gate.service';

function hasExpectedRole(expectedRole: UserRole): boolean {
  return inject(AuthService).getRole() === expectedRole;
}

function roleRedirect(expectedRole: UserRole, fallbackUrl: string) {
  return hasExpectedRole(expectedRole) ? true : inject(Router).parseUrl(fallbackUrl);
}

export const coachGuard: CanActivateFn = () => {
  const role = inject(AuthService).getRole();
  return role === 'coach' || role === 'admin'
    ? true
    : inject(Router).createUrlTree(['/today']);
};

export const athleteGuard: CanActivateFn = () => roleRedirect('athlete', '/dashboard');

export const coachMatchGuard: CanMatchFn = () => {
  const role = inject(AuthService).getRole();
  return role === 'coach' || role === 'admin';
};

export const athleteMatchGuard: CanMatchFn = () => hasExpectedRole('athlete');

export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  if (auth.getRole() === 'admin') {
    return true;
  }
  return inject(Router).createUrlTree(['/']);
};

// Eingeschränkter Account-Typ: sieht nur den /staff-Bereich.
export const staffGuard: CanActivateFn = () =>
  inject(AuthService).getRole() === 'staff' ? true : inject(Router).createUrlTree(['/']);

export const staffMatchGuard: CanMatchFn = () => inject(AuthService).getRole() === 'staff';

export function featureGuard(feature: string, fallbackUrl = '/today'): CanActivateFn {
  return () => {
    const auth = inject(AuthService);
    const gates = inject(FeatureGateService);
    const router = inject(Router);

    return auth.ensureEntitlementsLoaded()
      .pipe(map(() => (gates.canAccess(feature) ? true : router.parseUrl(fallbackUrl))));
  };
}
